import { Component, Input } from '@angular/core';

import { MaterialCaptchaSelection } from '../../../business/material-captcha-model/material-captcha-selection';

@Component({
    selector: 'ecm-mat-captcha-steps',
    templateUrl: './material-captcha-steps.component.html',
    styleUrls: ['./material-captcha-steps.component.css'],
})
export class MaterialCaptchaStepsComponent {
    /**
     * indications
     *  @type {any[]}
     */
    @Input() public indications: any[];

    /**
     * customer selections
     * @type {MaterialCaptchaSelection[]}
     */
    @Input() public selections: MaterialCaptchaSelection[];

    /**
     * Is User agent mobile
     * @type {boolean}
     */
    @Input() public isMobile: boolean;

    /**
     * Indications from captcha response
     * @type {string[]}
     */
    @Input() public captchaIndications: string[];

    /**
     * Get last selection
     * @returns {number}
     */
    public lastSelection(): number {
        return this.selections.length - 1;
    }

    /**
     * Delete last choice from selections
     */
    public deleteLastChoice(): void {
        if (this.isMobile) {
            if (this.captchaIndications.length === this.selections.length) {
                this.selections.pop();
            } else {
                this.selections.pop();
                this.indications.pop();
            }
        } else {
            this.selections.pop();
        }
    }
}
